export const splitData = (data, separator) => {
    const top = data?.length ? data?.slice(0, separator) : []
    const bottom = data?.length ? data?.slice(separator, data.length) : []

    return [top, bottom]
}
